import React, { useContext, useLayoutEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { smLayout } from '../styles/homeStyles';

import { LayoutContext } from '../context/layoutContext';

import { POPUP_NAME } from '../constants/index';
import { setCookie } from '../helpers/cookies';
import { TextBox } from '../styles/globalStyles';
import { useHistory } from 'react-router-dom';

import SubIndex from '../sub-index';
import { MdOutlineClose } from 'react-icons/md';

const MainUrlPopupItem = ({ data, position }) => {
  const { matchese } = useContext(LayoutContext);
  const [open, setOpen] = useState(true);

  const history = useHistory();

  const [popupData, setPopupData] = useState('');

  useLayoutEffect(() => {
    if (data?.id) {
      setPopupData(data);
    }
  }, [data]);

  const goUrl = () => {
    if (popupData?.linkType === 'program') {
      if (!popupData?.linkProgram) return;
      history.push(process.env.PUBLIC_URL + `/vod-detail?id=${popupData?.linkProgram?.id}&tab=-1`);
      setOpen(false);
    } else if (popupData?.linkType === 'url') {
      if (!popupData?.link) return;
      window.open(popupData?.link, '_blank');
      setOpen(false);
    } else {
      setOpen(false);
    }
  };

  const closePopup = option => {
    if (option) {
      var today = new Date();
      today.setDate(today.getDate() + 1);

      const title = `${POPUP_NAME}_${popupData?.id}`;
      setCookie(title, true, { expires: today, path: '/' });
      setOpen(false);
    } else {
      setOpen(false);
    }
  };

  return (
    <SubIndex>
      <PopupContainer open={open} position={`${position}0%`}>
        <div className='background' />
        <section>
          <div style={{ width: '100%', height: '100%', cursor: 'pointer', position: 'relative' }}>
            <div className='close' onClick={() => closePopup(false)}>
              <MdOutlineClose />
            </div>

            {popupData && (
              <img
                onClick={goUrl}
                alt='promotionBanner'
                src={
                  matchese
                    ? popupData?.mobileImg instanceof Array
                      ? popupData?.mobileImg[0]?.url
                      : popupData?.mobileImg?.url
                    : popupData?.img instanceof Array
                    ? popupData?.img[0]?.url
                    : popupData?.img?.url
                }
                style={{ width: '100%', height: '100%', objectFit: matchese ? 'fill' : 'cover' }}
              />
            )}
          </div>

          <TextBox
            style={{
              fontSize: '13px',
              cursor: 'pointer',
              backgroundColor: '#ffffff',
            }}
            onClick={() => closePopup(true)}
          >
            오늘 하루 더이상 보지 않음
          </TextBox>
        </section>
      </PopupContainer>
    </SubIndex>
  );
};

const PopupContainer = styled.div`
  opacity: 0;
  height: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s;
  display: none;

  ${props =>
    props.open &&
    css`
      width: 100vw;
      height: 100vh;

      opacity: 1;
      visibility: visible;
      pointer-events: auto;

      display: block;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999999999;

      .background {
        position: fixed;
        background-color: rgba(0, 0, 0, 0.2);
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
      }

      section {
        /* 310px * 443px */
        //max-width: 310px;
        max-height: 443px;

        top: 50%;
        left: calc(40% + ${props.position});

        background-color: #ffffff;
        box-shadow: 0px 0px 19px 4px rgba(0, 0, 0, 0.3);

        transform: translate(-50%, -50%);
        height: 90vh;
        position: absolute;

        ${smLayout} {
          width: 90% !important;
          max-width: 100% !important;
          max-height: 443px !important;
          left: 50% !important;
        }
      }

      .close {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        position: absolute;
        right: 0;
      }
    `}
`;

export default MainUrlPopupItem;
